/*
This is to check for the situation where a user cannot modify their items-type signup.

This happens when they have paid for the max # of item slots allowed. When that happens,
They can't cancel anything, and can't sign up for more items, so we need to use this to
hide the "Modify" button.
*/

export function checkIfCannotModifyItems({ signupItem, userSignupItem }) {
  const allItemsArePaid = userSignupItem.respondents?.every(
    (r) => r.paymentStatus === "Paid"
  );
  const singleUserSlotsAreMaxedOut =
    userSignupItem.count >= signupItem.maxSingleUserSlots;
  const signupItemSlotsAreMaxedOut =
    signupItem.slotsTaken >= signupItem.totalSlots;
  const noMoreSlotsAvailable =
    singleUserSlotsAreMaxedOut || signupItemSlotsAreMaxedOut;

  return allItemsArePaid && noMoreSlotsAvailable;
}
